import React from "react";
import Topbar from "../Topbar/Topbar";
import ProfileNavBar from "../ProfileNavbar";
import { Outlet, useLocation } from "react-router-dom";

const Layout = () => {
  const location = useLocation();
  // console.log("ADAS", location.pathname);

  return (
    <div className="dashboard">
      <div className="d-flex w-100">
        <ProfileNavBar />
        <div
          className={
            location.pathname === "/dashboard"
              ? "dashboardRightView"
              : "dashRightView"
          }
        >
          {/* <Topbar /> */}
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default Layout;
